import type { FC } from "react";

import type { Perioquiz } from "@/types/api/perioquiz";

interface PerioquizCardProps {
  perioquiz: Perioquiz;
  onSelect: (selected: Perioquiz) => void;
}

const PerioquizCard: FC<PerioquizCardProps> = ({ perioquiz, onSelect }) => {
  return (
    <div
      className="px-5 py-5 items-center border bg-white rounded-lg relative cursor-pointer"
      onClick={() => onSelect(perioquiz)}
    >
      <div className="text-xs text-gray-500">
        {`Réponses du `}
        <div className="text-xs text-black inline">
          {new Date(perioquiz.createdAt).toLocaleDateString()}
        </div>
      </div>
    </div>
  );
};

export default PerioquizCard;
